import PhoneInput from '@perpay-web/components/base/PhoneInput/PhoneInput';
import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';

const FormikPhoneInput = withFormikInputWrapper(PhoneInput);

/**
 * @type { any }
 */
export default FormikPhoneInput;
